import { useSelector } from 'react-redux'
import { useState, useEffect } from "react";
import { Grid } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import StickyHeadTestCasesTable from '../components/Table/StickyHeadTestCasesTable';
import GeneralNoPaginationTable from '../components/Table/GeneralNoPaginationTable';
import MainCard from '../components/MainCard';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';


const columns = [
  { id: 'hardware', label: 'Hardware' , align: 'left'},
  { id: 'bucket', label: 'Bucket', align: 'center'},
  { id: 'user_agent', label: 'User agent', align: 'center'},
  { id: 'prefix', label: 'Prefix', align: 'center'},
  { id: 'direction', label: 'Direction', align: 'center'},
  { id: 'trigger', label: 'Trigger parser', align: 'center'},
  { id: 'ip_limit', label: 'Limit IP', align: 'center'},
];

const summaries_columns = [
  { id: 'total', label: '', align: 'center'},
  { id: 'data_type', label: '', align: 'center'},
  { id: 'Jul-24', label: 'Jul-24', align: 'center'},
  { id: 'Aug-24', label: 'Aug-24', align: 'center'},
  { id: 'Sep-24', label: 'Sep-24', align: 'center'},
  { id: 'Oct-24', label: 'Oct-24', align: 'center'},
  { id: 'Nov-24', label: 'Nov-24', align: 'center'},
  { id: 'Dec-24', label: 'Dec-24', align: 'center'},
  { id: 'Jan-25', label: 'Jan-25', align: 'center'},
  { id: 'Feb-25', label: 'Feb-25', align: 'center'},
  { id: 'Mar-25', label: 'Mar-25', align: 'center'},
  { id: 'Apr-25', label: 'Apr-25', align: 'center'},
  { id: 'May-25', label: 'May-25', align: 'center'},
  { id: 'Jun-25', label: 'Jun-25', align: 'center'},
  { id: 'Jul-25', label: 'Jul-25', align: 'center'},
  { id: 'Aug-25', label: 'Aug-25', align: 'center'},
];

const TestRailCaseInfoPage = () => {
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();
    const [allData, setAllData] = useState(null);
    const [summariesData, setSummariesData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getTestrailCases = async () => {
            try {
                const response = await axios.post("/peloton/v1/automation/testrail-cases-report", null, { withCredentials: true});
                if (response.data.message === "success"){
                    setAllData(response.data.all_data);
                    setSummariesData(response.data.summaries_data);
                }
            } catch (error) {
                if (error.response.status !== null){
                    if (error.response.status === 401){
                        alert(error.response.data.message);
                        navigate("/");
                    }else{
                        console.log('error.response.status: ', error.response.status)
                        console.log('error.response.message: ', error.response.data.message)
                    }
                }else{
                    console.log(error);
                }
            }finally {
                setLoading(false);
            }
        };
        getTestrailCases();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setAllData]);

    if (loading) {
        return <div>Loading...</div>;
    }


    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "45px", marginLeft: "40px"}}>
            <MainCard title={'Created and Updated Test Cases'}>
            <Grid item xs={12} >
                <GeneralNoPaginationTable rows={summariesData} columns={summaries_columns} title="Created and Updated Test Cases"/>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "20px"}}>
                {customization.login && (<StickyHeadTestCasesTable allData={allData} columns={columns} title="TWN SQA Test Cases Improvement Data Collection"/>)}
            </Grid>
            </MainCard>
        </Grid>
    );
};

export default TestRailCaseInfoPage;
